import { render, staticRenderFns } from "./ZoomImagen.vue?vue&type=template&id=2fff22c2&scoped=true"
import script from "./ZoomImagen.vue?vue&type=script&lang=js"
export * from "./ZoomImagen.vue?vue&type=script&lang=js"
import style0 from "./ZoomImagen.vue?vue&type=style&index=0&id=2fff22c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff22c2",
  null
  
)

export default component.exports